module.exports = __webpack_public_path__ + "img/banner.136d617e.png";